import { useQuery } from '@tanstack/react-query'
import { Card, Flex, Heading, Text } from '@radix-ui/themes'
import { useTRPC } from '~/utils/trpc'
import type { SuggestionFields } from '../labels'
import { MeterPhotoDropZone } from './MeterPhotoDropZone'
import { MeterPhotoGrid } from './MeterPhotoGrid'
import { SuggestionPanel } from './SuggestionPanel'

/** The photos a customer or ops sent of this meter before installation, and what the model makes of them. */
export const MeterPhotosCard = ({ installation }: { installation: SuggestionFields }) => {
  const trpc = useTRPC()
  const photos = useQuery(
    trpc.ops.compatibilityReview.photos.queryOptions({ installationId: installation.installation_id })
  )

  return (
    <Card>
      <Flex direction="column" gap="3">
        <Heading size="3">Meter photos</Heading>
        {photos.isLoading ? (
          <Text size="2" color="gray">
            Loading…
          </Text>
        ) : photos.error ? (
          <Text size="2" color="red">
            {photos.error.message}
          </Text>
        ) : (
          <MeterPhotoGrid photos={photos.data ?? []} />
        )}
        <MeterPhotoDropZone installationId={installation.installation_id} />
        <SuggestionPanel installation={installation} hasPhotos={(photos.data ?? []).length > 0} />
      </Flex>
    </Card>
  )
}
